import React, { useState } from 'react';
import styled from 'styled-components';
import { useDidMount, useLazyFetchData } from '../../../../utils/hooks';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../../../shared/LoadingSpinner';

const IDENTITY_CONFIRMATION_COLORS = {
    idConfirmationText: '#000F1B99',
    idConfirmationValue: '#00061BD1',
  };

const IdentityConfirmationRow = styled.div`
    display: flex;
    width: 100%;
`;
const IdentityConfirmationCol = styled.div`
    width: 50%;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 480px;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.foreground};
`;
const IdConfirmationText = styled.p`
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    color: ${IDENTITY_CONFIRMATION_COLORS.idConfirmationText};
    margin: 0;
`;
const IdConfirmationValue = styled.p`
    font-weight: 600;
    font-size: 60px;
    line-height: 64px;
    color: ${IDENTITY_CONFIRMATION_COLORS.idConfirmationValue};
    margin: 0;
`;

const IdentityConfirmation = () => {
    const { t } = useTranslation();
    const [idConfirmationFetchData, setIdConfirmationFetchData] = useState({
        onboardUsed: 0, verifyUsed: 0});

    const [getReportData, { loading: reportsLoading },] = useLazyFetchData({
        endpoint: '/user/verification/reports',
        onSuccess: (data) => {
            setIdConfirmationFetchData({
                ...idConfirmationFetchData,
                onboardUsed: data?.onboardUsed,
                verifyUsed: data?.verifyUsed
            });
        },
        onError: (err) => {
            console.log('err', err);
        }
    });

    useDidMount(() => {
        getReportData();
    });

    return (
        <>
            <IdentityConfirmationRow>
                <IdentityConfirmationCol style={{marginRight: '15px'}}>
                    <IdConfirmationText>{t("reports$identityConfirmation$column$onboard")}</IdConfirmationText>
                    <IdConfirmationValue>{idConfirmationFetchData?.onboardUsed ? idConfirmationFetchData?.onboardUsed : 0}</IdConfirmationValue>
                </IdentityConfirmationCol>
                <IdentityConfirmationCol style={{marginLeft: '15px'}}>
                    <IdConfirmationText>{t("reports$identityConfirmation$column$verify")}</IdConfirmationText>
                    <IdConfirmationValue>{idConfirmationFetchData?.verifyUsed ? idConfirmationFetchData?.verifyUsed : 0}</IdConfirmationValue>
                </IdentityConfirmationCol>
            </IdentityConfirmationRow>
            {reportsLoading && <LoadingSpinner />}
        </>
    )
}

export default IdentityConfirmation;
